const backgrounds = {
  modal: {
    modalScrimBackground: 'rgba(30, 37, 53, 0.6)',
  },
};

export { backgrounds };
